import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { User } from '../../../services/user.service';
import { ClientService, Client } from '../../../services/client.service';
import { catchError, of } from 'rxjs';
import { LoggerService } from '../../../core/services/logger.service';

@Component({
    selector: 'app-delete-user-dialog',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule
    ],
    templateUrl: './delete-user-dialog.component.html',
    styleUrl: './delete-user-dialog.component.scss'
})
export class DeleteUserDialogComponent implements OnInit {
    clientInfo: Client | null = null;
    isLoadingClient = false;
    clientError = false;

    constructor(
        // eslint-disable-next-line no-unused-vars
        public dialogRef: MatDialogRef<DeleteUserDialogComponent>,
        // eslint-disable-next-line no-unused-vars
        @Inject(MAT_DIALOG_DATA) public data: { user: User },
        // eslint-disable-next-line no-unused-vars
        private clientService: ClientService,
        private logger: LoggerService
    ) {}

    ngOnInit(): void {
        // Si el usuario tiene rol de cliente y tiene client_id, obtener información del cliente
        if (this.data.user.role === 'client' && this.data.user.client_id) {
            this.loadClientInfo();
        }
    }

    private loadClientInfo(): void {
        this.isLoadingClient = true;
        this.clientError = false;
        
        this.clientService.getClientById(this.data.user.client_id!)
            .pipe(
                catchError(error => {
                    this.logger.error(
                        'Error al obtener información del cliente',
                        error as Error,
                        'DeleteUserDialogComponent'
                    );
                    this.clientError = true;
                    return of(null);
                })
            )
            .subscribe(response => {
                this.isLoadingClient = false;
                if (response) {
                    this.clientInfo = response;
                } else {
                    this.clientError = true;
                }
            });
    }

    onConfirm(): void {
        this.dialogRef.close(true);
    }

    onCancel(): void {
        this.dialogRef.close(false);
    }

    getUserFullName(): string {
        return `${this.data.user.first_name} ${this.data.user.last_name}`;
    }

    shouldShowClientInfo(): boolean {
        return this.data.user.role === 'client' && this.data.user.client_id !== undefined;
    }
} 